import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment-timezone';
// import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { VehicleBookingService } from '../vehicle-booking.service';
import { VehicleBooking } from '../vehicle-booking';
import { ReservationService } from '@app/_components/reservation/reservation.service';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-vehicle-booking',
    templateUrl: './vehicle-booking.component.html',
    styleUrls: ['./vehicle-booking.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class VehicleBookingComponent implements OnInit {
	vehicles: any;
	agencies: any;
	pickupDrops: any;
	reservationId: any;
	reservation: any;

	constructor(
		private primengConfig: PrimeNGConfig,
		private vehicleBookingService: VehicleBookingService,
		private reservationService: ReservationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.vehicleBooking = data.vehicleBooking,
			this.reservation = data.reservation,
			this.reservationId = data.reservationId,
			this.statuses = vehicleBookingService.statuses;
			this.vehicles = vehicleBookingService.vehicles;
			this.agencies = vehicleBookingService.agencies;
			this.pickupDrops = vehicleBookingService.pickupDrops;
	}

	@Input() vehicleBooking: VehicleBooking;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	vehicleBookingId: number;
	orderId: string; // Store the extracted orderId from reservation

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'vehicleBookingId': [],
		'vehiclePref': [
			{ type: 'required', message: 'Required' }
		],
		'reservationId': [],
		'pickUpLocPref': [{ type: 'required', message: 'Required' }],
		'dropOffLocPref': [{ type: 'required', message: 'Required' }],
		'pickUpDateTimePref': [{ type: 'required', message: 'Required' }],
		'dropOffDateTimePref': [{ type: 'required', message: 'Required' }],
		'pickUpLoc': [],
		'dropOffLoc': [],
		'pickUpDateTime': [],
		'dropOffDateTime': [],
		'cancelDate': [],
		'bookingStatus': [],
		'agencyConfNumber': [],
		'agencyName': [],
		'agencyVehicleBooked': [],
		'primaryDriverName': [{ type: 'required', message: 'Required' }],
		'notesFromCustomer': [],
		'notesToCustomer': [],
		'notesToOps': [],
		'contractTerms': [],
		'numOfDaysRental': [],
		'retailUpgradeCostPerDay': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();


		// if we were passed the whole vehicleBooking object
		if (this.vehicleBooking) {
			this.vehicleBookingId = this.vehicleBooking.vehicleBookingId;
			this.vehicleBooking.pickUpDateTimePref = this.parseDate(this.vehicleBooking.pickUpDateTimePref);
			this.vehicleBooking.dropOffDateTimePref = this.parseDate(this.vehicleBooking.dropOffDateTimePref);
			this.vehicleBooking.pickUpDateTime = this.parseDate(this.vehicleBooking.pickUpDateTime);
			this.vehicleBooking.dropOffDateTime = this.parseDate(this.vehicleBooking.dropOffDateTime);
			this.vehicleBooking.cancelDate = this.parseDate(this.vehicleBooking.cancelDate);
			this.fixDates();
			this.form1.patchValue(this.vehicleBooking);

			// Check if vehicleBooking has reservationId and fetch orderId
			if (this.vehicleBooking && this.vehicleBooking.reservationId) {
				this.fetchReservationOrderId();
			}
		}else{
			if(this.reservation){
				const timeZone = moment.tz.guess(); // Automatically detect user's timezone
				this.reservation.checkInDate = moment(this.reservation?.checkInDate)
					.set({ hour: 12, minute: 0, second: 0, millisecond: 0 }) // Set to 12 PM
					.toDate();
				this.reservation.checkOutDate = moment(this.reservation?.checkOutDate)
					.set({ hour: 12, minute: 0, second: 0, millisecond: 0 }) // Set to 12 PM
					.toDate();
				this.form1.patchValue({
					vehiclePref:'compact',
					primaryDriverName: this.reservation?.guestProfile?.firstName +" "+ this.reservation?.guestProfile?.lastName,
					reservationId: this.reservation?.reservationId,
					pickUpDateTimePref: this.reservation.checkInDate,
					dropOffDateTimePref: this.reservation.checkOutDate,
					agencyName: "Budget",
					bookingStatus:2
				});
			}
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.vehicleBookingId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			const payload = this.buildPayload();
			payload?.vehicleBookingId ? delete payload.vehicleBookingId : '';

			this.vehicleBookingService.add(payload)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.vehicleBooking = res.data.vehicleBooking;
						this.doAdd.emit(this.vehicleBooking);
					},
					(err: any) => {
						console.log('vehicleBooking-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('vehicleBooking: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			this.formLoading = true;

			this.vehicleBookingService.update(this.buildPayload())
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.vehicleBooking = res.data.vehicleBooking;
						this.doUpdate.emit(this.vehicleBooking);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.formLoading = true;
			this.vehicleBookingService.delete(this.vehicleBooking.vehicleBookingId)
				.subscribe(
					(res: any) => {
						console.log('vehicleBooking-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.vehicleBooking);
					},
					(err: any) => {
						console.log('vehicleBooking-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			vehicleBookingId: [this.vehicleBookingId],
			'vehiclePref': ['',Validators.required],
			'reservationId': [],
			'pickUpLocPref': ['',Validators.required],
			'dropOffLocPref': ['',Validators.required],
			'pickUpDateTimePref': ['',Validators.required],
			'dropOffDateTimePref': ['',Validators.required],
			'pickUpLoc': [],
			'dropOffLoc': [],
			'pickUpDateTime': [],
			'dropOffDateTime': [],
			'cancelDate': [],
			'bookingStatus': [],
			'agencyConfNumber': [],
			'agencyName': [],
			'agencyVehicleBooked': [],
			'primaryDriverName': ['',Validators.required],
			'notesFromCustomer': [],
			'notesToCustomer': [],
			'notesToOps': [],
			'contractTerms': [],
			'numOfDaysRental': [],
			'retailUpgradeCostPerDay': [],
		});
	}

	fixDates() {
		// Parse vehicleBookingDate if present
		if (this.vehicleBooking && this.vehicleBooking.vehicleBookingDate) {
			this.vehicleBooking.vehicleBookingDate = this.parseDate(this.vehicleBooking.vehicleBookingDate);
		}
	}

	/**
	 * Parse date string from server to local Date object for display
	 * Handles timezone correctly by treating date strings as timezone-agnostic values
	 */
	private parseDate(value: any): Date | null {
		if (!value) return null;

		// If already a Date, return as-is
		if (value instanceof Date) {
			return value;
		}

		// Accept: yyyy-MM-dd or yyyy-MM-ddTHH:mm:ss
		const s = value.replace('Z', '');
		const [datePart, timePart] = s.split('T');

		const [y, m, d] = datePart.split('-').map(Number);

		let hh = 0, mm = 0, ss = 0;
		if (timePart) {
			const t = timePart.split(':');
			hh = Number(t[0] || 0);
			mm = Number(t[1] || 0);
			ss = Number((t[2] || '0').substring(0, 2));
		}

		// IMPORTANT:
		// This creates a local Date with EXACT same fields
		// No UTC, no offset math
		return new Date(y, m - 1, d, hh, mm, ss);
	}

	/**
	 * Format date value to string for API (timezone-agnostic)
	 * Extracts date and time components directly
	 */
	private formatDate(value: any): string | null {
		if (!value) return null;

		// Already backend string → return as-is
		if (typeof value === 'string') {
			return value.replace('Z', '');
		}

		const d = value as Date;

		const y = d.getFullYear();
		const m = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		const hh = String(d.getHours()).padStart(2, '0');
		const mm = String(d.getMinutes()).padStart(2, '0');
		const ss = String(d.getSeconds()).padStart(2, '0');

		return `${y}-${m}-${day}T${hh}:${mm}:${ss}`;
	}

	/**
	 * Build payload with formatted dates for API
	 */
	private buildPayload(): any {
		const v = { ...this.form1.value };

		// Format all date-time fields
		v.pickUpDateTimePref = this.formatDate(v.pickUpDateTimePref);
		v.dropOffDateTimePref = this.formatDate(v.dropOffDateTimePref);
		v.pickUpDateTime = this.formatDate(v.pickUpDateTime);
		v.dropOffDateTime = this.formatDate(v.dropOffDateTime);
		v.cancelDate = this.formatDate(v.cancelDate);

		return v;
	}

	/*********
	 * Fetch Reservation OrderId
	 * Calls ReservationService.findById when vehicleBooking has reservationId
	 */
	fetchReservationOrderId() {
		if (!this.vehicleBooking || !this.vehicleBooking.reservationId) {
			return;
		}

		this.reservationService.findById(this.vehicleBooking.reservationId)
			.pipe(first())
			.subscribe(
				(res: any) => {
					if (res.data && res.data.reservation && res.data.reservation.order) {
						this.orderId = res.data.reservation.order.orderId;
						console.log('Extracted orderId from reservation: ' + this.orderId);

						// Example: Update form with orderId if needed
						// this.form1.patchValue({ orderId: this.orderId });
					} else {
						console.log('No orderId found in reservation data');
					}
				},
				(err: any) => {
					console.log('Error fetching reservation: ' + JSON.stringify(err));
					this.messageService.add({
						severity: 'error',
						summary: 'Error',
						detail: 'Failed to load reservation data',
						life: 3000
					});
				}
			);
	}

	openReservation() {
		if (this.vehicleBookingId && this.orderId) {
			window.open(`https://admin.kbmhawaii.com/order/${this.orderId}`, '_blank');
		}
	}

	onVehicleChange(event: any) {
		const selectedVehicle = this.vehicles.find(v => v.value === event.value);

		if (selectedVehicle) {
			this.form1.patchValue({
				retailUpgradeCostPerDay: selectedVehicle.price
			});
		}
	}
}
